export default __webpack_public_path__ + "static/earlybird-51d98c388fbc61f5c0c47379640d767b.png";